<script>
	export let name;
</script>

<article>
	<h1>Bergabunglah dengan revolusi {name}! 🇵🇸</h1>
        <p id="app"></p>
        <p><small><strong>catatan:</strong> Aplikasi ini berjalan murni di browser Anda. Tidak ada gambar atau data yang akan disimpan oleh aplikasi.</small></p>
        <p class="result"></p>
        <p>Bagikan Twibbon ini ke media sosial Anda: <strong><em>Bagikan</em></strong>.</p>
</article>

<footer>
        <p><a target="_blank" rel="noopener" href="/">&copy; 2024 Ferry Ayunda. All rights reserved.</a></p>
</footer>

<style>
	article {
                margin: 2.5em auto 0 auto;
                border: 1px solid;
                border-color: #aaa #ddd;
                padding: 2em;
                background: #fff;
        }

	h1 {
		text-transform: uppercase;
                margin-top: 0;
	}

        em {
        color: #38488f;
        text-decoration: none;
        }

        small {
        color: grey;
        font: 7pt Arial;
        }

	@media all and (max-width:700px){
                article,footer {
                margin: 0 auto;
                width: auto;
        }
                body {
                font-size: 1em;
        }
        }
</style>
